module.exports = __webpack_public_path__ + "static/billboard_2-46a6b019ca1e1ad99cb0129d7c85327b.png";